module.exports = "https://web-assets.ifttt.com/packs/media/perks/health-a77ebd3d.svg";